import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=879538b0"
import script from "./vModal.vue?vue&type=script&lang=js"
export * from "./vModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports